import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { COMPANY } from '../data/site';

function Shell({ title, testid, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid={testid} className="min-h-screen bg-slate-50 pb-24 pt-36">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand transition-colors hover:text-brand-hover"
        >
          <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
        </Link>
        <h1 className="mt-8 font-display text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">{title}</h1>
        <div className="mt-10 space-y-8 rounded-3xl border border-slate-200 bg-white p-8 text-sm leading-relaxed text-slate-600 sm:p-10">
          {children}
          <p className="rounded-xl bg-slate-50 p-4 text-xs text-slate-400">
            Hinweis: Dies ist ein Muster-Text. Bitte lassen Sie die Inhalte vor Veröffentlichung rechtlich prüfen.
          </p>
        </div>
      </div>
    </main>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-bold text-navy">{title}</h2>
      <div className="mt-3 space-y-2">{children}</div>
    </section>
  );
}

export function Impressum() {
  return (
    <Shell title="Impressum" testid="impressum-page">
      <Block title="Angaben gemäß § 5 TMG">
        <p className="font-semibold text-navy">{COMPANY.name}</p>
        <p>Inhaber: Nils Falkenstein &amp; Paul Müller</p>
        <p>{COMPANY.street}</p>
        <p>{COMPANY.city}</p>
      </Block>
      <Block title="Kontakt">
        <p>E-Mail: {COMPANY.email}</p>
        <p>Internet: {COMPANY.website}</p>
      </Block>
      <Block title="Umsatzsteuer-ID">
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: wird nachgereicht.</p>
      </Block>
      <Block title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV">
        <p>Nils Falkenstein &amp; Paul Müller, {COMPANY.street}, {COMPANY.city}</p>
      </Block>
      <Block title="Haftung für Inhalte">
        <p>
          Die Inhalte dieser Seiten wurden mit großer Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
        </p>
      </Block>
    </Shell>
  );
}

export function Datenschutz() {
  return (
    <Shell title="Datenschutzerklärung" testid="datenschutz-page">
      <Block title="1. Verantwortliche Stelle">
        <p className="font-semibold text-navy">{COMPANY.name}</p>
        <p>{COMPANY.street}, {COMPANY.city}</p>
        <p>E-Mail: {COMPANY.email}</p>
      </Block>
      <Block title="2. Erhebung und Verarbeitung von Daten">
        <p>
          Bei Nutzung unseres Kontaktformulars verarbeiten wir die von Ihnen angegebenen Daten
          (Name, Telefonnummer, E-Mail-Adresse, Adressen, Wunschtermin, Leistungsart und Nachricht)
          ausschließlich zur Bearbeitung Ihrer Anfrage gemäß Art. 6 Abs. 1 lit. b DSGVO.
        </p>
      </Block>
      <Block title="3. Weitergabe von Daten">
        <p>
          Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht. Die Daten werden nur so lange
          gespeichert, wie es für die Bearbeitung Ihrer Anfrage erforderlich ist.
        </p>
      </Block>
      <Block title="4. Ihre Rechte">
        <p>
          Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung
          der Verarbeitung Ihrer personenbezogenen Daten sowie ein Beschwerderecht bei der
          zuständigen Aufsichtsbehörde.
        </p>
      </Block>
      <Block title="5. Kontakt zum Datenschutz">
        <p>
          Bei Fragen zum Datenschutz wenden Sie sich bitte an {COMPANY.email}.
        </p>
      </Block>
    </Shell>
  );
}
